<template>
  <v-btn
    v-bind="$attrs"
    class="story-action-button py-2 px-4"
    outlined
    @click="$emit('click')"
  >
    <div class="btn-icon mr-1" :style="`height: ${iconSize}px;`">
      <slot name="icon" />
    </div>
    <div class="btn-text">
      <slot name="text" />
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "StoryCityStoryActionButton",
  props: {
    iconSize: {
      type: Number,
      default: 18,
    },
  }
};
</script>

<style lang="scss" scoped>
.story-action-button {
  border-color: var(--v-primaryFaded-base);
  border-radius: 8px;
}

.v-btn.story-action-button:before {
  background-color: var(--v-background-base);
}

.v-btn.story-action-button:hover:before {
  opacity: 1;
}

.btn-icon {
  width: auto;
}

.btn-text {
  color: var(--v-primaryText-base);
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}
</style>
